const DescriptionText = ({ heading, subHeading }) => (
  <div className='intro-text'>
    <h1 className='intro-text__heading'>{heading}</h1>
    <p className='intro-text__sub-heading'>{subHeading}</p>
  </div>
);

export default DescriptionText;
